exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".transition{\r\n  transition: opacity 1000ms ease-in-out,margin-left 500ms ease-in-out;\r\n  margin-left: 1500px;\r\n  width: 200px;\r\n  opacity: 0;\r\n}\r\n\r\n.transition{\r\n  opacity: 100;\r\n  margin-left: 0;\r\n}\r\n\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 284
// module chunks = 1